// src/components/Layout.js
import Header from "./Header";
import Footer from "./Footer";

export default function Layout({ children }) {
  return (
    <div className="flex flex-col min-h-screen bg-[var(--color-app-bg)]">
      <Header />
      <main className="flex-1 container-pad">
        {/* one container sets the page’s side padding */}
        {children}
      </main>
      <Footer />
    </div>
  );
}
